import { render, staticRenderFns } from "./FaqSectionUpdate.vue?vue&type=template&id=0d98cea0&scoped=true&"
import script from "./FaqSectionUpdate.vue?vue&type=script&lang=js&"
export * from "./FaqSectionUpdate.vue?vue&type=script&lang=js&"
import style0 from "./FaqSectionUpdate.vue?vue&type=style&index=0&id=0d98cea0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d98cea0",
  null
  
)

export default component.exports